"use client";

import { Private } from "@/components/page/private";
import { Can } from "@/components/page/private/can";
import { NewWork } from "@/components/page/private/newWork";
import { Deployment } from "@/components/page/private/deployment";
import { Branch } from "@/components/page/private/branch";
import { Access } from "@/components/page/private/access";
import { AutofitPageWrapper } from "@/components/AutofitPageWrapper";
import { Footer } from "@/components/footer";
import { useIsMobile } from "@/app/hooks/useIsMobile";
import { MobileFooter } from "@/components/mobile-footer";
import { HeaderMobile } from "@/components/header-mobile";
import { PrivateMobileSecond } from "@/components/page/private-mobile/second";
import { PrivateMobileThree } from "@/components/page/private-mobile/three";
import { PrivateMobileFourth } from "@/components/page/private-mobile/fourth";
import { PrivateMobileFive } from "@/components/page/private-mobile/five";
import { PrivateMobileSix } from "@/components/page/private-mobile/six";
import { PrivateMobileFirst } from "@/components/page/private-mobile/first";

export default function PrivatePageClient() {
  const isMobile = useIsMobile();

  if (isMobile === null)
    return <div className="w-screen h-screen bg-white" />;

  if (isMobile) {
    return (
      <div className="flex flex-col w-full h-screen overflow-y-auto">
        <HeaderMobile />
        <PrivateMobileFirst />
        <PrivateMobileSecond />
        <PrivateMobileThree />
        <PrivateMobileFourth />
        <PrivateMobileFive />
        <PrivateMobileSix />
        <MobileFooter />
        <div className="h-[20px] min-h-[20px]" />
      </div>
    );
  }

  return (
    <AutofitPageWrapper>
      <Private />
      <Can />
      <NewWork />
      <Deployment />
      <Branch />
      <Access />
      <Footer />
    </AutofitPageWrapper>
  );
}
